import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import router from './router'
import axios from 'axios'
import VueElementLoading from "vue-element-loading";
import AOS from 'aos'
import 'aos/dist/aos.css'
Vue.component("VueElementLoading", VueElementLoading);    

Vue.config.productionTip = false

// window.axios = require('axios')
// axios.defaults.baseURL = 'http://192.168.52.90:5400';
// Vue.prototype.baseURL = "http://192.168.52.90:5400"
// Vue.prototype.mediaURLnew = "http://192.168.52.90:5400/file/get/"
// Vue.prototype.mediaURL = "http:192.168.52.90:5400/u/"


// axios.defaults.baseURL = 'http://192.168.48.159:5400';
// Vue.prototype.baseURL = "http://192.168.48.159:5400"
// Vue.prototype.mediaURL = "http://192.168.48.159:5400/u/"
// Vue.prototype.mediaURLnew = "http://192.168.48.159:5400/wp/"

axios.defaults.baseURL = 'http://rainvalley.leopardtechlabs.com/';
Vue.prototype.baseURL = "http://rainvalley.leopardtechlabs.com/"
Vue.prototype.mediaURLnew = "http://rainvalley.leopardtechlabs.com/file/get/"

new Vue({   
  vuetify,
  router,
  render: h => h(App),
  mounted() {
    AOS.init()
  },
}).$mount('#app')
